import React from 'react';
import './style.css';

export default ({children, image, title, imageHref, target = null}) => (
    <div className="MediaObject">
        <div className="MediaObject-text">{children}</div>
        <div className="MediaObject-image">
            {imageHref ?
                <a href={imageHref} target={target}><img src={image} alt={title} width="300"/></a> :
                <img src={image} alt={title} width="300"/>
            }
        </div>
    </div>
)


// WEBPACK FOOTER //
// ./src/HomePage/MediaObject/index.js